var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.submodelElement !== undefined)?_c('div',[(_vm.getReference)?_c('reference-view',{attrs:{"reference":_vm.getReference}}):_c('div',{staticClass:"grey--text"},[_vm._v("<null>")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }